import { FileInput, FileOutput, GitCommitVertical, GitFork, LifeBuoy, Waypoints } from "lucide-react";
export const STEP_FIELD_ICONS = {
    input: FileInput,
    output: FileOutput,
    taskDescription: Waypoints,
    helpers: LifeBuoy
};
export const ACTION_TYPE_ICONS = {
    task: GitCommitVertical,
    decision: GitFork
};

//# sourceMappingURL=stepFieldIcons.js.map